import axios from "axios";
import BaseApi from "./base";
import {
  AUTH_CONTACT_US,
  AUTH_LOGIN,
  AUTH_TOKEN,
  AUTH_LOST,
  AUTH_REGISTER,
  GET_TIME,
  CHANGE_READY,
  SET_TIMEZONE,
  AUTH_LOGOUT,
  IFRAME_GET_URL,
  IFRAME,
  CREATE_ORDER,
  GET_CREATE_DATA,
  GET_KEEP_ALIVE,
  GET_PASSWORD,
  AUTH_SET_EMAIL
} from "../constants/api";

export default class extends BaseApi {
  static token(data) {
    return axios.post(AUTH_TOKEN, this.stringify(data), {
      headers: {
        Authorization: `Basic ${process.env.VUE_APP_BASIC_TOKEN}`,
      },
    });
  }

  static login(data) {
    return axios.post(AUTH_LOGIN, this.stringify(data));
  }

  static register(data) {
    return axios.post(AUTH_REGISTER, this.stringify(data));
  }

  static forgot(data) {
    return axios.post(AUTH_LOST, this.stringify(data));
  }

  static sendLetter(data) {
    return axios.post(AUTH_CONTACT_US, this.stringify(data));
  }

  static getTime() {
    return axios.get(GET_TIME);
  }

  static changeReady(data) {
    return axios.post(CHANGE_READY, this.stringify(data));
  }

  static keepAlive() {
    return axios.get(GET_KEEP_ALIVE);
  }

  static setTimezone(data) {
    return axios.post(SET_TIMEZONE, this.stringify(data));
  }

  static logout() {
    return axios.get(AUTH_LOGOUT);
  }

  static iframe(id, data) {
    return axios.post(IFRAME + "/" + id, this.stringify(data));
  }

  static iframeGetUrl(data) {
    return axios.get(IFRAME_GET_URL + "/" + data.id, {
      params: {
        operator: data.operator,
      },
    });
  }

  static createData(data) {
    return axios.post(GET_CREATE_DATA, this.stringify(data));
  }

  static createOrder(data) {
    return axios.post(CREATE_ORDER, this.stringify(data));
  }

  static getPassword(data) {
    return axios.post(GET_PASSWORD, this.stringify(data));
  }

  static setEmail(data) {
    return axios.post(AUTH_SET_EMAIL, this.stringify(data));
  }
}
